import { Divider } from 'antd';
import React from 'react';
import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  & > form {
    flex: 1;
  }
`;

export const FormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StepContent = styled.div`
  padding: 24px;

  h3.ant-typography {
    text-align: center;
  }
`;

export const FormGroup: React.FC<{
  children: React.ReactNode;
  title: string;
}> = ({ children, title }) => {
  return (
    <>
      <Divider orientation="left">{title}</Divider>
      {children}
    </>
  );
};
